module.exports = __webpack_public_path__ + "img/home.4087c566.svg";